<!-- ==================== TEMPLATE DEFINITIONS ==================== -->

<!-- Regular Image Data Content -->
<ng-template #basicContent>
  <h5 *ngIf="!imageData?.boundSetName" [ngStyle]="{'white-space': (expandMode === 3 || expandMode === 2) ? 'break-spaces' : 'nowrap'}" 
      [matTooltip]="imageData?.name | imageName : imageData?.orderNo" 
      [matTooltipPosition]="'right'" 
      [matTooltipShowDelay]="tooltipDelay">
    {{ truncate(imageData?.name | imageName : imageData?.orderNo, expandMode === 3 ? 52 : 100, true) }}
  </h5>
  <h5 *ngIf="imageData?.boundSetName" [ngStyle]="{'white-space': (expandMode === 3 || expandMode === 2) ? 'break-spaces' : 'nowrap'}" 
      [matTooltip]="imageData?.boundSetName | imageName : imageData?.orderNo" 
      [matTooltipPosition]="'right'" 
      [matTooltipShowDelay]="tooltipDelay">
    {{ truncate(imageData?.boundSetName | imageName : imageData?.orderNo, expandMode === 3 ? 52 : 100, true) }}
  </h5>

  <h6 class="location" title="Location">{{ imageData?.location }}&nbsp;</h6>
  <h6 class="dateline" *ngIf="imageData?.relevantDates?.length && (imageData?.relevantDates[0]?.year > 0); else blankH6">
    {{ imageData?.relevantDates?.length ? longMonth(imageData?.relevantDates[0]?.month) : '' }}
    {{ imageData?.relevantDates?.length ? (imageData?.relevantDates[0]?.day === 0 ? '' : imageData.relevantDates[0]?.day + ',') : '' }}
    {{ imageData?.relevantDates?.length ? imageData?.relevantDates[0]?.year : ''}}
  </h6>
  <ng-template #blankH6><h6></h6></ng-template>
  <h6 class="battle" *ngIf="imageData?.battleLinks" title="Battle">
    {{ imageData.battleLinks[0]?.battle?.name }}
  </h6>
</ng-template>

<!-- Related Set View Data Content -->
<ng-template #RSVbasicContent>
  <h5 [matTooltip]="relatedImageSetViewData?.name" 
      [matTooltipPosition]="'right'" 
      [matTooltipShowDelay]="tooltipDelay">
    {{relatedImageSetViewData.name}}
  </h5>
  <h6 style="text-align: left;" *ngFor="let name of relatedImageSetViewData.imageNames">
    {{name}}
  </h6>
</ng-template>

<!-- Ledger Set Data Content -->
<ng-template #ledgerContent>
  <h5 class="ledger-title" 
      [matTooltip]="relatedImageSetViewData?.name" 
      [matTooltipPosition]="'right'" 
      [matTooltipShowDelay]="tooltipDelay">
    <i class="fas fa-book-open"></i>
    {{ truncate(relatedImageSetViewData?.name, expandMode === 3 ? 52 : 100, true) }}
  </h5>
  <h6 class="ledger-info">
    <i class="far fa-file-alt"></i> {{ relatedImageSetViewData?.imageCount }} Pages
  </h6>
  <h6 class="location ledger-info" title="Location" *ngIf="relatedImageSetViewData?.thumbnailImage?.location">
    <i class="fas fa-map-marker-alt"></i> {{ relatedImageSetViewData.thumbnailImage.location }}&nbsp;
  </h6>
  <h6 class="dateline ledger-info" *ngIf="relatedImageSetViewData?.thumbnailImage?.relevantDates?.length && (relatedImageSetViewData.thumbnailImage.relevantDates[0]?.year > 0)">
    <i class="far fa-calendar"></i>
    {{ relatedImageSetViewData.thumbnailImage.relevantDates[0] | date:'MMMM d, yyyy' }}
  </h6>
  <h6 class="ledger-description" *ngIf="relatedImageSetViewData?.thumbnailImage?.notes">
    <i class="fas fa-sticky-note"></i>
    {{ truncate(relatedImageSetViewData.thumbnailImage.notes, 100) }}
  </h6>
</ng-template>

<!-- Source Pop Under -->
<ng-template #sourcePopUnder>
  <div *ngIf="showSourceInfo && hovering && (sourceData$ | async)" 
       [@basicFade] 
       class="dataContainer popUnder row" 
       [ngClass]="{'popUnderListBar': expandMode === 2, 'popUndersmallGrid': expandMode === 0, 'popUnderLargeGrid': expandMode === 1, 'popUnderSidebar': expandMode === 3, 'nonRSVModeDataContainer': !isGalleryMode}">
    <div class="sourceContainer">

      <div class="col-4" *ngIf="imageData?.source?.logoPath">
        <img class="source-logo" [src]="imageData?.source?.logoPath">
      </div>
      <div class="col-8 source-love" *ngIf="imageData?.source" 
          [matTooltip]="'Thanks to ' + imageData?.source?.source + '.'" 
          [matTooltipShowDelay]="tooltipDelay">
        <a *ngIf="isStringUrl(imageData?.source.homePageUrl); else justSourceName" 
          title="Click to visit their homepage" 
          [href]="imageData?.source?.homePageUrl" 
          target="_blank" 
          rel="noopener noreferrer" 
          class="btn btn-link"
          [ngStyle]="!isGalleryMode ? {'white-space': 'normal'} : ''">
          {{ imageData?.source?.source }}
        </a>
        <ng-template #justSourceName>
          <span class="btn">{{ imageData.source.source }}</span>
        </ng-template>
      </div>

    </div>
  </div>
</ng-template>

<!-- ==================== MAIN THUMBNAIL CONTAINER ==================== -->
<div class="componentContainer" [ngClass]="{'listbar': expandMode === 2}">
  <div class="thumbnailContainer" 
      (mouseover)="hovering = true" 
      (mouseleave)="hovering = false" 
      [ngClass]="{
        'sidebar': expandMode === 3, 
        'listbar': expandMode === 2, 
        'animate': animate && !hasTemplate, 
        'largeGrid': expandMode === 1,
        'smallGrid': expandMode === 0, 
        'featured': (!isRelatedImageSetViewMode && thumbnailType === 'regular' && imageData?.featured),
        'mobile': isHandset,
        'has-template': hasTemplate,
        'overflow-hidden': expandMode === 1 || expandMode === 0
          }" 
      [class]="getThumbnailTypeClass()"
      (click)="selectRecord()"
      [ngStyle]="getContainerBackgroundStyle()">
    
    <!-- UNIVERSAL TEMPLATE APPROACH: Two sibling divs for ANY template type -->
    <ng-container *ngIf="hasTemplate">
      <!-- Image layer (bottom) -->
      <div class="template-image-layer" 
          [ngStyle]="{
            'background-image': 'url(' + this.imagePath + ')',
            'width': templateConfig.imageSize.width,
            'height': templateConfig.imageSize.height,
            'transform': templateConfig.imageTransform || 'translate(-50%, -50%)'
          }">
      </div>
      
      <!-- Frame layer (top) -->
      <div class="template-frame-layer" 
          [ngStyle]="{'background-image': 'url(' + templateConfig.templatePath + ')'}">
      </div>
    </ng-container>
    
    <!-- Source Pop Under (not shown for related sets) -->
    <ng-container *ngIf="!isRelatedImageSetViewMode">
      <ng-container *ngTemplateOutlet="sourcePopUnder"></ng-container>
    </ng-container>
    
    <!-- Eye Icon for Checked Out Records -->
    <div class="eyeHolder" 
        *ngIf="imageData?.checkedOut" 
        matTooltip="This record is not visible to subscribers." 
        [matTooltipShowDelay]="tooltipDelay">
      <i class="far fa-eye-slash"></i>
    </div>
    
    <!-- Star Icon for Featured Records -->
    <div class="starHolder" 
        *ngIf="!isRelatedImageSetViewMode && thumbnailType === 'regular' && (imageData?.featured && !imageData?.checkedOut)" 
        matTooltip="This is a featured record." 
        [matTooltipShowDelay]="tooltipDelay" 
        [matTooltipPosition]="'right'">
      <i class="fa-star" [ngClass]="{'far': !hovering, 'fas': hovering}"></i>
    </div>
    
    <!-- Batch Edit Mode Checkbox -->
    <div class="checkboxHolder" 
        [ngClass]="{'checked': selected, 'largeGrid': expandMode == libraryViewModes.gridLargeMode}" 
        *ngIf="batchEditMode" 
        [matTooltip]="selected ? 'Click the thumbnail to add this record to your selection.' : 'Click the thumbnail to remove this record from your selection.'" 
        [matTooltipShowDelay]="tooltipDelay">
      <i class="fal fa-check-square" *ngIf="selected"></i>
      <i class="fal fa-square" *ngIf="!selected"></i>
    </div>

    <!-- Batch Edit Mode: Selection Number -->
    <div class="selectedNumberHolder" *ngIf="batchEditMode && sequenceNumber > 0">
      {{ sequenceNumber }}
    </div>
    
    <!-- Update Sequence Mode -->
    <div class="selectedNumberHolder" *ngIf="updateSeqMode && rsSequenceNumber >= 0">
      <div *ngIf="!rsSelected">
        {{ rsSequenceNumber }}
      </div>
      <div *ngIf="rsSelected" class="updateSeqContainer">
        <input #updateSeqInput 
              class="updateSeqInput" 
              mask="000" 
              [(ngModel)]="updatedNo" 
              (keyup.enter)="sendUpdatedSeqNo()" 
              (keyup.esc)="cancelSeqNoUpdate()">
        <div class="updateSeqTooltip">
          <i class="fas fa-info-circle" 
            [matTooltip]="'Press \'ENTER\' to apply changes, \'ESC\' to discard changes.'"></i>
        </div>
      </div>
    </div>
    
    <!-- Data Container with Mode-Specific Content -->
    <div class="dataContainer" 
        name="imageData?.name" 
        [ngClass]="{
          'dataContainer-overlay': expandMode === 0 && (thumbnailType !== 'ledgerSet' || isRelatedImageSetViewMode), 
          'dataContainer-overlay-large': expandMode === 1 && thumbnailType !== 'ledgerSet', 
          'dataContainer-sidebar': expandMode === 3, 
          'dataContainer-listbar': expandMode === 2,
          'dataContainer-vis-overide': thumbnailType == 'ledgerSet' && isRelatedImageSetViewMode
        }">
      
      <!-- Summary Mode Display (expandMode === 3) -->
      <div *ngIf="expandMode === 3">
        <!-- Ledger Mode Content -->
        <ng-container *ngIf="thumbnailType === 'ledgerSet'">
          <ng-container *ngTemplateOutlet="ledgerContent"></ng-container>
        </ng-container>
        
        <!-- Related Set View Mode Content -->
        <ng-container *ngIf="isRelatedImageSetViewMode && thumbnailType !== 'ledgerSet'">
          <ng-container *ngTemplateOutlet="RSVbasicContent"></ng-container>
        </ng-container>
        
        <!-- Regular Image Content -->
        <ng-container *ngIf="!isRelatedImageSetViewMode">
          <ng-container *ngTemplateOutlet="basicContent"></ng-container>
        </ng-container>
      </div>
      
      <!-- List Mode Display (expandMode === 2) -->
      <div *ngIf="expandMode === 2" class="row-container">
        <div class="row">
          <!-- Ledger List Mode Content -->
          <div *ngIf="thumbnailType === 'ledgerSet'" class="col-5 title">
            <h5 class="ledger-title">
              <i class="fas fa-book-open"></i>
              {{ truncate(relatedImageSetViewData?.name, 40, true) }}
            </h5>
            <h6 class="ledger-info">
              <i class="far fa-file-alt"></i> {{ relatedImageSetViewData?.imageCount }} Pages
            </h6>
            <h6 class="location ledger-info" *ngIf="relatedImageSetViewData?.thumbnailImage?.location">
              <i class="fas fa-map-marker-alt"></i> {{ relatedImageSetViewData.thumbnailImage.location }}
            </h6>
          </div>
          <div *ngIf="thumbnailType === 'ledgerSet'" class="col-7 notes">
            <h6 class="dateline" *ngIf="imageData?.relevantDates?.length && (imageData?.relevantDates[0]?.year > 0)">
              {{ imageData?.relevantDates?.length ? longMonth(imageData?.relevantDates[0]?.month) : '' }}
              {{ imageData?.relevantDates?.length ? (imageData?.relevantDates[0]?.day === 0 ? '' : imageData.relevantDates[0]?.day + ',') : '' }}
              {{ imageData?.relevantDates?.length ? imageData?.relevantDates[0]?.year : ''}}
            </h6>
            <h6 *ngIf="imageData?.notes">{{truncate(imageData?.notes, 150)}}</h6>
            <h6 *ngFor="let kw of keywordsToShow">{{kw.keyword}}</h6>
            <div class="mt-2" *ngIf="matchedRecordText">
              <span class="badge bg-warning text-dark">
                <i class="fas fa-search"></i> 
                {{ relatedImageSetViewData.matchedRecords }} matches found
              </span>
            </div>
          </div>
          
          <!-- Regular list mode content for non-ledger -->
          <div *ngIf="thumbnailType !== 'ledgerSet'" class="col title">
            <ng-container *ngTemplateOutlet="isRelatedImageSetViewMode ? RSVbasicContent : basicContent"></ng-container>
          </div>
          <div *ngIf="thumbnailType !== 'ledgerSet'" class="col notes">
            <div *ngIf="imageData; else loading" class="keywords">
              <strong>Keywords: </strong>
              <app-keyword-badge [fontSize]="'1'" *ngFor="let k of keywordsToShow" [keyword]="k" [searchText]="searchTerm" [filterMatchText]="searchTerm" (filterByMeEmitter)="reloadEmitter.emit($event); searchTerm = $event.keyword;"></app-keyword-badge>
            </div>
            <ng-template #loading>
              <div class="keywords"></div>
            </ng-template>
            <div class="note">
              <strong>Notes: </strong>{{ imageData?.notes }}
            </div>
          </div>
        </div>
      </div>
      
      <!-- Grid Mode Display (expandMode === 0 or 1) -->
      <div *ngIf="expandMode === 0 || expandMode === 1">
        <!-- Only show content for non-templated thumbnails in grid views -->
        <ng-container *ngIf="thumbnailType !== 'ledgerSet' || isRelatedImageSetViewMode">
          <ng-container *ngTemplateOutlet="isRelatedImageSetViewMode ? RSVbasicContent : basicContent"></ng-container>
        </ng-container>
      </div>
    </div>

    <!-- Record Count Text for Related Sets (non-ledger) -->
    <div *ngIf="isRelatedImageSetViewMode && thumbnailType !== 'ledgerSet' && !matchedRecordText" class="recordText">
      <i class="far fa-search"></i>
      {{relatedImageSetViewData.imageCount}} Records
    </div>
    <div *ngIf="isRelatedImageSetViewMode && thumbnailType !== 'ledgerSet' && matchedRecordText" class="recordText">
      <i class="far fa-search"></i>
      {{relatedImageSetViewData.matchedRecords}} out of {{relatedImageSetViewData.imageCount}} matches.
    </div>
  </div>

  <!-- Record Count Text for Related Sets (ledger) -->
  <div *ngIf="isRelatedImageSetViewMode && thumbnailType == 'ledgerSet' && !matchedRecordText" class="recordText" style="bottom: -1.75em;">
    <i class="far fa-search"></i>
    {{relatedImageSetViewData.imageCount}} Records
  </div>
  <div *ngIf="isRelatedImageSetViewMode && thumbnailType == 'ledgerSet' && matchedRecordText" class="recordText" style="bottom: -1.75em;">
    <i class="far fa-search"></i>
    {{relatedImageSetViewData.matchedRecords}} out of {{relatedImageSetViewData.imageCount}} matches.
  </div>

  <!-- Record Count Text for Ledger Sets - OUTSIDE main container -->
  <div *ngIf="!isRelatedImageSetViewMode && thumbnailType === 'ledgerSet' && (expandMode === 0 || expandMode === 1)" 
      class="recordText ledger-record-text"
      [ngClass]="{'recordText-overlay-large': expandMode === 1}">
    <div>
      <strong>{{relatedImageSetViewData.name}}</strong>
    </div>
    
    <!-- Show match text if filters are active -->
    <div *ngIf="matchedRecordText" class="mt-1">
      <span class="badge bg-warning text-dark">
        <i class="fas fa-search"></i>
        {{relatedImageSetViewData.matchedRecords}} of {{relatedImageSetViewData.imageCount}} matches
      </span>
    </div>
    
    <!-- Show simple page count if no filters -->
    <div *ngIf="!matchedRecordText">
      {{relatedImageSetViewData.imageCount}} Pages
    </div>
  </div>
</div>
